import React, {Component} from 'react'
import {Card, Icon} from 'antd'
import {Link} from 'react-router-dom'

class Widget extends Component {
  render() {
    const {
      title,
      iconThemeUpper,
      iconUpper,
      iconTheme,
      icon,
      iconColor,
      value,
      subTitle,
      footer,
      footerValue,
      link,
      fetching,
    } = this.props
    return (
      <Card bordered={false} loading={fetching} style={{marginTop: 24}}>
        <div>
          <div
            style={{width: '100%', position: 'relative', overflow: 'hidden'}}>
            <div>
              <span>{title}</span>
              <Icon
                type={iconUpper}
                theme={iconThemeUpper}
                style={{float: 'right'}}
              />
            </div>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                wordBreak: 'break-all',
                whiteSpace: 'nowrap',
                color: 'rgba(0,0,0,.85)',
                marginTop: '4px',
                marginBottom: '10px',
                fontSize: '30px',
                lineHeight: '38px',
              }}>
              <Icon type={icon} theme={iconTheme} style={{color: iconColor}} />
              <span style={{marginLeft: 10}}>{value}</span>
            </div>
          </div>

          {subTitle && (
            <div
              style={{
                height: '46px',
                marginBottom: '12px',
                position: 'relative',
                width: '100%',
                color: 'rgba(0,0,0,.85)',
              }}>
              {Array.isArray(subTitle) ? (
                subTitle.map(st => (
                  <span
                    style={{
                      marginRight: '16px',
                      display: 'inline-block',
                      fontSize: '14px',
                      width: '100%',
                      lineHeight: '22px',
                    }}>
                    {st}
                  </span>
                ))
              ) : (
                <span
                  style={{
                    marginRight: '16px',
                    fontSize: '14px',
                    width: '100%',
                    display: 'inline-block',
                    lineHeight: '22px',
                  }}>
                  {subTitle}
                </span>
              )}
            </div>
          )}
          {footer && (
            <Link to={link} activeStyle={null}>
              <div
                style={{
                  borderTop: '1px solid #e8e8e8',
                  paddingTop: '9px',
                  marginTop: '8px',
                }}>
                <div
                  style={{
                    position: 'relative',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    margin: '0',
                  }}>
                  <span
                    style={{
                      fontSize: '14px',
                      lineHeight: '22px',
                      marginLeft: '8px',
                    }}>
                    {footer}
                  </span>
                  {footerValue && (
                    <span style={{marginLeft: '8px'}}>{footerValue}</span>
                  )}
                </div>
              </div>
            </Link>
          )}
        </div>
      </Card>
    )
  }
}

export default Widget
